import React, { Component } from "react";
import "./style.css";
import "../../../../../index.css";
class SubjectRankDeclare extends Component {
  render() {
    return (
      <div className="subjectRankDeclare_box">
        <div className="subjectRankDeclare_inline_box">
          <div>
            <span>*</span>
            此排名来源于教育部学位与研究生教育发展中心的第四轮学科评估。
          </div>
          <div style={{ marginTop: 20 }}> 将前70%的学科分9档公布</div>
          {/* <div>A+ ：前2%（或前2名）</div>
          <div>A ：2%～5%（不含2%，下同）</div>
          <div>A- ：5%～10%</div>
          <div>B+ ：10%～20%</div>
          <div>B：20%～30%</div>
          <div>B- ：30%～40%</div>
          <div>C+ ：40%～50%</div>
          <div>C：50%～60%</div>
          <div>C- ：60%～70%</div> */}
          <table>
            <tbody>
              <tr>
                <td className="blod">A+</td>
                <td className="blod">:</td>
                <td>前2%（或前2名）</td>
              </tr>
              <tr>
                <td className="blod">A</td>
                <td className="blod">:</td>
                <td>2%～5%（不含2%，下同）</td>
              </tr>
              <tr>
                <td className="blod">A-</td>
                <td className="blod">:</td>
                <td>5%～10%</td>
              </tr>
              <tr>
                <td className="blod">B+</td>
                <td className="blod">:</td>
                <td>10%～20%</td>
              </tr>
              <tr>
                <td className="blod">B</td>
                <td className="blod">:</td>
                <td>20%～30%</td>
              </tr>
              <tr>
                <td className="blod">B-</td>
                <td className="blod">:</td>
                <td>30%～40%</td>
              </tr>
              <tr>
                <td className="blod">C+</td>
                <td className="blod">:</td>
                <td>40%～50%</td>
              </tr>
              <tr>
                <td className="blod">C</td>
                <td className="blod">:</td>
                <td>50%～60%</td>
              </tr>
              <tr>
                <td className="blod">C-</td>
                <td className="blod">:</td>
                <td>60%～70%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default SubjectRankDeclare;



// WEBPACK FOOTER //
// ./src/containers/Rank/SubjectRank/components/SubjectRankDeclare/index.js